import { Meta } from 'aimo-ui';
import SelectableModalContentItem from 'components/common/SelectableModalContentItem';
import Icon from 'components/icons/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePermitStore } from 'stores/permitStore';
import { BillingFrequency, BillingInterval } from 'types/generatedSchemaTypes';
import { isIntervalAllowed } from 'utils/permitUtils';
import { useUiStore } from 'stores/uiStore';

const BillingIntervalsModalContent = () => {
  const { t } = useTranslation();
  const { selectedBillingFrequency, billingIntervals = [] } =
    usePermitStore((state) => state.selectedPermitBillingInterval) ?? {};
  const setSelectedPermitBillingInterval = usePermitStore(
    (state) => state.setSelectedPermitBillingInterval
  );

  const onPress = (interval: BillingInterval) => {
    setSelectedPermitBillingInterval({
      selectedBillingFrequency: interval as BillingFrequency,
      billingIntervals,
    });
    useUiStore.getState().setSheetModal('');
  };

  return (
    <>
      {billingIntervals?.filter(isIntervalAllowed).map((interval) => {
        const selected = selectedBillingFrequency === interval;
        return (
          <SelectableModalContentItem
            key={interval}
            isSelected={selected}
            disabled={false}
            iconNodeRight={selected ? <Icon name="check" /> : null}
            notSelectedBorder
            onPress={() => onPress(interval)}
            itemTitle={t(`longTermParking.billingFrequencies.${interval}`)}
            iconNode={undefined}>
            <Meta>{t(`longTermParking.billingFrequencies.${interval}`)}</Meta>
          </SelectableModalContentItem>
        );
      })}
    </>
  );
};

export default BillingIntervalsModalContent;
